<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial && seccion === 'LISTADO'">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioEstadoCambio" name="nomFormularioEstadoCambio">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_DESDEESTADO' | translate }}</label>
          <label class="falso-combo-texto">{{f.nombreEstadoPrincipal.value}}</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_HASTAESTADO' | translate }}</label>
          <div *ngIf="!f.idProductoEstadoRelacion.value">
            <p-dropdown disableTab  id="idEstadoPasar" name="nomEstadoPasar" [options]="lisEstados" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idEstado"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
              {{ 'PRODUCTOESTADO.LBL_HASTAESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <label *ngIf="f.idProductoEstadoRelacion.value" class="falso-combo-texto">{{f.nombreEstado.value}}</label>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_FORMULARIO' | translate }}</label>
          <p-dropdown disableTab  id="idFormulario" name="nomFormulario" [options]="lisFormularios" filter="filter"
                      (onChange)="cargarListadoControles($event.value)"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idFuncionalidadControlPadre"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFuncionalidadControlPadre.invalid">
            {{ 'PRODUCTOESTADO.LBL_FORMULARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_CONTROL' | translate }}</label>
          <p-dropdown disableTab  id="idControl" name="nomControl" [options]="lisControles" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idFuncionalidadControlHijo"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFuncionalidadControlHijo.invalid">
            {{ 'PRODUCTOESTADO.LBL_CONTROL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <p-checkbox label="{{ 'PRODUCTOESTADO.LBL_INDICADORFASE' | translate}}" binary="true"
                    id="idIndicadorFase"
                    name="nomIndicadorFase" (onChange)="cambioMantieneFase($event)"
                    formControlName="indicadorMantieneFase"></p-checkbox>
      </div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf="!f.indicadorMantieneFase.value">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_FASE' | translate }}</label>
          <p-dropdown disableTab  id="idFase" name="nomFase" [options]="lisFases" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idFase"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFase.invalid">
            {{ 'PRODUCTOESTADO.LBL_FASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>{{ 'PRODUCTOESTADO.LBL_TIPOCAUSAL' | translate }}</label>
          <p-dropdown disableTab  id="idTipoCausal" name="nomTipoCausal" [options]="lisTiposCausales" filter="filter"
                      (onChange)="cambioTipoCausal($event.value)"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idTipoCausal"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCausal.invalid">
            {{ 'PRODUCTOESTADO.LBL_TIPOCAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>{{ 'PRODUCTOESTADO.LBL_CAUSALES' | translate }}</label>
          <p-multiSelect id="idCausales" name="nomCausales" [options]="lisCausales" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="causales"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.causales.invalid">
            {{ 'PRODUCTOESTADO.LBL_CAUSALES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>


    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <p-checkbox label="{{ 'PRODUCTOESTADO.LBL_INDICADORNOTIFICACIONES' | translate}}" binary="true"
                    id="idIndicadorManejaNotificaciones"
                    name="nomIndicadorManejaNotificaciones" (onChange)="cambioNotificaciones($event)"
                    formControlName="indicadorManejaNotificaciones"></p-checkbox>
      </div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorManejaNotificaciones.value">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_NOTIFICACION' | translate }}</label>
          <p-multiSelect id="idNotificaciones" name="nomNotificaciones" [options]="lisNotificaciones" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idNotificaciones"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNotificaciones.invalid">
            {{ 'PRODUCTOESTADO.LBL_NOTIFICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12" [class]="f.indicadorManejaNotificaciones.value ? 'md:col-12 lg:col-12' : 'md:col-6 lg:col-6'">
        <p-checkbox label="{{ 'PRODUCTOESTADO.LBL_SOLICITUD' | translate}}" binary="true"
                    id="indicadorSolicitudTradicional"
                    name="indicadorSolicitudTradicional"
                    formControlName="indicadorSolicitudTradicional"></p-checkbox>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <p-checkbox label="{{ 'PRODUCTOESTADO.LBL_PREAPROBADO' | translate}}" binary="true"
                    id="indicadorPreaprobado"
                    name="indicadorPreaprobado" (onChange)="cambioTipoPreAprobado($event)"
                    formControlName="indicadorPreaprobado"></p-checkbox>
      </div>
      <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorPreaprobado.value">
        <div class="div-form">
          <label>* {{ 'PRODUCTOESTADO.LBL_TIPOPREAPROBADO' | translate }}</label>
          <p-multiSelect id="tiposPreAprobado" name="tiposPreAprobado" [options]="lisTiposPreAprobados" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="tiposPreAprobado"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tiposPreAprobado.invalid">
            {{ 'PRODUCTOESTADO.LBL_TIPOPREAPROBADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>


    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{(f.idProductoEstadoRelacion.value ? 'BTN_ACTUALIZAR' :'BTN_AGREGAR') | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="guardando"
               [value]="lisProductoEstadoCambio"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreEstadoPrincipal}}</td>
            <td>{{row.nombreEstado}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorMantieneFase" binary="true" disabled="true"></p-checkbox>
            </td>
            <td>{{row.nombreFuncionalidadPadre}}</td>
            <td>{{row.nombreFuncionalidadHijo}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorSolicitudTradicional" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              {{row.preAprobado}}
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BTN_VISUALIZAR' | translate}}"
                        pButton (click)="ver(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-users" data-toggle="tooltip"
                        title="{{'PRODUCTOESTADO.BTN_ROLES' | translate}}" pButton
                        (click)="relacionarRoles(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhabilitar(row)"></button>

              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="submit" (click)="regresar()"
              pButton></button>
    </div>
  </div>
</div>

<app-producto-estado-aliado-rol *ngIf="seccion==='ROLES'" (dismiss)="cambioSeccion($event)"
                                [proEstadoCambio]="proEstadoCambioSeleccionado"></app-producto-estado-aliado-rol>


<p-confirmDialog #cd key="producto-estado-relacionar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mosCausales"
          header="{{ 'PRODUCTOESTADO.LBL_CAUSALES'  | translate}}"
          [modal]="true">
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      <p-table [columns]="colCausales"
               [value]="lisCausalesSeleccionadas"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreCausal}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrar()"></button>
    </div>
  </div>
</p-dialog>
